module.exports = __webpack_public_path__ + "img/tessera_sanitaria.0a07dd0d.jpg";